module.exports = __webpack_public_path__ + "images/emoji/hibiscus.3e89104fe87427f28dad.png";